module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-53.43923338.jpg";